import { graphql } from '@/gql';
import type { HomeServiceProviderInputType } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const updateHomeServiceProvider = async ({ id, data }: { id: number; data: HomeServiceProviderInputType }) => {
  const response = await mutationExecute({
    variables: {
      id,
      data,
    },
    mutation: graphql(`
      mutation UpdateHomeServiceProvider($id: Float!, $data: HomeServiceProviderInputType!) {
        updateHomeServiceProvider(id: $id, data: $data) {
          id
        }
      }
    `),
  });

  return response.data?.updateHomeServiceProvider;
};
